export type User = {
  id: number;
  lastName: string;
  firstName: string;
  email: string;
  RPPS: number;
  password: string;
  passwordResetCode: string | null;
  passwordResetDateCreatedAt: Date | null;
  customerId: string | null;
  subscriptionId: string | null;
  subscriptionStatus: SubscriptionStatus | null;
  subscriptionTier: SubscriptionTier | null;
  createdAt: Date;
  updatedAt: Date;
};

export type Login = {
  user: User;
  token: string;
};

export const SubscriptionStatus = {
  TRIALING: "TRIALING",
  ACTIVE: "ACTIVE",
  INCOMPLETE: "INCOMPLETE",
  INCOMPLETE_EXPIRED: "INCOMPLETE_EXPIRED",
  PAST_DUE: "PAST_DUE",
  CANCELED: "CANCELED",
  UNPAID: "UNPAID",
  PAUSED: "PAUSED",
};

export type SubscriptionStatus =
  (typeof SubscriptionStatus)[keyof typeof SubscriptionStatus];

export const SubscriptionTier = {
  FULL: "FULL",
  TEST: "TEST",
};

export type SubscriptionTier =
  (typeof SubscriptionTier)[keyof typeof SubscriptionTier];

export const getSubscriptionLabelAndPrice = (
  subscriptionTier: SubscriptionTier
) => {
  switch (subscriptionTier) {
    default:
    case SubscriptionTier.FULL:
      return {
        label: "complet",
        monthlyPrice: 69,
        yearlyPrice: 699,
      };
    case SubscriptionTier.TEST:
      return {
        label: "test",
        monthlyPrice: 0,
        yearlyPrice: 0,
      };
  }
};

export const getSubscriptionPriceInfo = (priceId: string) => {
  switch (priceId) {
    case "price_1SebwnFZ7CP02e8kMH8aD6bz":
    case "price_1SexZLFDjE9cPZZTp5WcK8Q1":
      return {
        label: "Complet",
        monthly: true,
        monthlyPrice: 69,
        yearlyPrice: 699,
      };
    case "price_1SebwnFZ7CP02e8kK7G8jj9v":
    case "price_1SexZLFDjE9cPZZThXk0rEVX":
      return {
        label: "Complet",
        monthly: false,
        monthlyPrice: 69,
        yearlyPrice: 699,
      };
    case "price_1SebxHFZ7CP02e8ktnQsg4Ij":
    case "price_1Sexa5FDjE9cPZZTYDIWmZ6N":
      return {
        label: "Test",
        monthly: true,
        monthlyPrice: 0,
        yearlyPrice: 0,
      };
    case "price_1SebzXFZ7CP02e8keigR8BIZ":
    case "price_1Sexa5FDjE9cPZZT4C7VnDTl":
      return {
        label: "Test",
        monthly: false,
        monthlyPrice: 0,
        yearlyPrice: 0,
      };
    default:
      return {
        label: "Non abonné",
        monthly: true,
        monthlyPrice: 0,
        yearlyPrice: 0,
      };
  }
};
